<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.5 16.6667C3.96447 16.6667 2.1967 16.6667 1.09835 15.4462C-9.93411e-08 14.2259 0 12.2617 0 8.33333C0 4.40496 -9.93411e-08 2.44077 1.09835 1.22039C2.1967 -9.93411e-08 3.96447 0 7.5 0C11.0355 0 12.8033 -9.93411e-08 13.9017 1.22039C15 2.44077 15 4.40496 15 8.33333C15 12.2617 15 14.2259 13.9017 15.4462C12.8033 16.6667 11.0355 16.6667 7.5 16.6667ZM10 3.33333H5C4.61251 3.33333 4.41877 3.33333 4.25981 3.37592C3.82844 3.49151 3.49151 3.82844 3.37592 4.25981C3.33333 4.41877 3.33333 4.61251 3.33333 5C3.33333 5.38749 3.33333 5.58123 3.37592 5.74019C3.49151 6.17156 3.82844 6.50849 4.25981 6.62407C4.41877 6.66667 4.61251 6.66667 5 6.66667H10C10.3875 6.66667 10.5812 6.66667 10.7402 6.62407C11.1716 6.50849 11.5085 6.17156 11.6241 5.74019C11.6667 5.58123 11.6667 5.38749 11.6667 5C11.6667 4.61251 11.6667 4.41877 11.6241 4.25981C11.5085 3.82844 11.1716 3.49151 10.7402 3.37592C10.5812 3.33333 10.3875 3.33333 10 3.33333ZM5 9.16667C5 9.62691 4.6269 10 4.16667 10C3.70643 10 3.33333 9.62691 3.33333 9.16667C3.33333 8.70642 3.70643 8.33333 4.16667 8.33333C4.6269 8.33333 5 8.70642 5 9.16667ZM7.5 10C7.96025 10 8.33333 9.62691 8.33333 9.16667C8.33333 8.70642 7.96025 8.33333 7.5 8.33333C7.03975 8.33333 6.66667 8.70642 6.66667 9.16667C6.66667 9.62691 7.03975 10 7.5 10ZM11.6667 9.16667C11.6667 9.62691 11.2936 10 10.8333 10C10.3731 10 10 9.62691 10 9.16667C10 8.70642 10.3731 8.33333 10.8333 8.33333C11.2936 8.33333 11.6667 8.70642 11.6667 9.16667ZM10.8333 13.3333C11.2936 13.3333 11.6667 12.9602 11.6667 12.5C11.6667 12.0397 11.2936 11.6667 10.8333 11.6667C10.3731 11.6667 10 12.0397 10 12.5C10 12.9602 10.3731 13.3333 10.8333 13.3333ZM8.33333 12.5C8.33333 12.9602 7.96025 13.3333 7.5 13.3333C7.03975 13.3333 6.66667 12.9602 6.66667 12.5C6.66667 12.0397 7.03975 11.6667 7.5 11.6667C7.96025 11.6667 8.33333 12.0397 8.33333 12.5ZM4.16667 13.3333C4.6269 13.3333 5 12.9602 5 12.5C5 12.0397 4.6269 11.6667 4.16667 11.6667C3.70643 11.6667 3.33333 12.0397 3.33333 12.5C3.33333 12.9602 3.70643 13.3333 4.16667 13.3333Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'PayeEstimateIcon',
  inheritAttrs: false,
  props: {
    width: {
      type: [Number, String],
      default: 15
    },
    height: {
      type: [Number, String],
      default: 17
    }
  }
}
</script>